<mat-expansion-panel [expanded]="true" class="slim-panel-body" togglePosition="before">
  @if(showHeader) {
    <mat-expansion-panel-header>
      <div class="tw-w-full column-grid tw-gap-2 tw-grid-cols-[auto_1fr]">
        <mat-panel-title>
          <div class="tw-grid">
            <div class="column-grid tw-gap-2">
              {{approval.name}}
              @if(approval.isTest) {
                <span class="tw-font-bold">(Test)</span>
              }
            </div>
            <div>
              {{approval.loanProductName}}
            </div>
          </div>
        </mat-panel-title>
        <mat-panel-description class="tw-w-full">
          <div class="column-grid tw-justify-between tw-w-full">
            <div class="column-grid tw-place-items-center tw-gap-6">
              @for(item of headerPreviewData(); track $index) {
                <div>
                  <div class="tw-text-xs">{{item.label}}</div>
                  <div class="tw-font-bold tw-text-lendio-cool-gray-600">{{item.value}}</div>
                </div>
              }
            </div>

            <div class="tw-flex">
              <recommend-option-toggle
                class="tw-flex tw-pr-2"
                [value]="approval.isRecommended"
                [isShort]="true"
                (change)="recommendedToggleChange($event)"
              ></recommend-option-toggle>

              <app-approval-menu-smart
                class="tw-flex"
                [approval]="approval"
                [hideCreateOptionButton]="hideCreateOptionButton"
                (createOption)="createOfferOption()"
              >

                <div class="approval-status tw-font-bold">
                    Status: <span [class]="'published-marker__' + publishedStatus().toLowerCase()"
                    class="column-inline-grid tw-items-center"
                  >
                    {{ publishedStatus() }}
                    @if(publishedStatus() === 'Declined') {
                      <app-decline-info-tooltip [declineReasons]="approval.declineReasons"></app-decline-info-tooltip>
                    }
                  </span>
                </div>

              </app-approval-menu-smart>
            </div>
          </div>
        </mat-panel-description>
      </div>
    </mat-expansion-panel-header>
  }

  <div class="tw-w-full column-grid tw-grid-cols-[70%_1fr] tw-pb-2">

    @if( functionalApproval?.attributesMap ) {
      <section class="tw-pr-4">

        <!-- PAYMENT FREQUENCY -->
        <div class="column-grid tw-gap-4 tw-place-items-center tw-justify-start tw-pb-[12px]">
          <mat-label>Payment Frequency</mat-label>
          <app-restricted-radio
            class="w-100 ml-1 pt-1"
            [options]="functionalApproval.availablePaymentFrequencies"
            [availableOptions]="availableFrequencyValues()"
            [disabled]="false"
            (valueChange)="changePaymentFrequency($event)"
            [value]="functionalApproval.selectedPaymentFrequency.value"
          />
        </div>

        <div class="tw-grid tw-gap-6 tw-h-fit">
          @for(attribute of inputableAttributes(); track $index) {
            <app-approval-attribute-input [attribute]="attribute" [functionalApproval]="functionalApproval" />
          }
        </div>

        <div>
          {{functionalApproval.calculateScheduleParams | json}}
        </div>

      </section>

      <div class="tw-grid tw-gap-[12px] tw-h-fit tw-pt-4">
        @for(item of outputsDisplayData(); track $index) {
          <div class="column-grid tw-justify-between">
            <div>{{item.label}}</div>
            <div class="tw-font-bold">{{item.value}}</div>
          </div>
        }

        @if(approval.offerLink) {
          <a class="tw-text-center" target="_blank" href="{{approval.offerLink}}">
            <button
              data-cy="send-to-bp-btn"
              mat-button
              color="primary">
              Offer Link
            </button>
          </a>
        }
      </div>

    }

  </div>

  <div class="benefits tw-mb-2">
    <app-value-props-smart [option]="approval" optionType="approval"></app-value-props-smart>
  </div>

</mat-expansion-panel>
